import { GoogleBasemapNames, Platforms } from '../types';

export const MAX_COG_OPACITY = 1;

export const DEFAULT_COG_OPACITY = MAX_COG_OPACITY;

export type COGOpacityThreshold = {
    minExclusive: number;
    maxInclusive: number;
    opacity: number;
};

type DimmedCOGOpacityThresholds = Record<GoogleBasemapNames, COGOpacityThreshold[]>;

/**
 * Zoom thresholds to create gradual opacity smoothing.
 * Note that deck.gl layer transitions would be ideally used instead here, but the behavior
 * seems wonky (transition works as expected when zooming in but not zooming out). More info:
 * https://deck.gl/docs/api-reference/core/layer#transitions
 */
export const cogZoomOpacityThresholds: COGOpacityThreshold[] = [
    {
        minExclusive: 5,
        maxInclusive: 9,
        opacity: MAX_COG_OPACITY
    },
    {
        minExclusive: 9,
        maxInclusive: 10,
        opacity: MAX_COG_OPACITY - 0.1
    },
    {
        minExclusive: 10,
        maxInclusive: 12,
        opacity: MAX_COG_OPACITY - 0.2
    },
    {
        minExclusive: 12,
        maxInclusive: 19,
        opacity: MAX_COG_OPACITY - 0.4
    }
];

/**
 * Dimmed rasters use separate zoom thresholds, with opacity values tuned by platform and basemap.
 * Satellite stays more opaque than roadmap, and MethaneAIR (which doesn't use a gresyscale palette)
 * is generally dimmer than MethaneSAT.
 */
export const cogZoomOpacityThresholdsDimmed: Record<Platforms, DimmedCOGOpacityThresholds> = {
    [Platforms.MSAT]: {
        [GoogleBasemapNames.Satellite]: [
            {
                minExclusive: 5,
                maxInclusive: 9,
                opacity: MAX_COG_OPACITY - 0.1
            },
            {
                minExclusive: 9,
                maxInclusive: 19,
                opacity: MAX_COG_OPACITY - 0.35
            }
        ],
        [GoogleBasemapNames.Roadmap]: [
            {
                minExclusive: 5,
                maxInclusive: 10,
                opacity: MAX_COG_OPACITY - 0.8
            },
            {
                minExclusive: 10,
                maxInclusive: 11,
                opacity: MAX_COG_OPACITY - 0.7
            },
            {
                minExclusive: 11,
                maxInclusive: 19,
                opacity: MAX_COG_OPACITY - 0.8
            }
        ]
    },
    [Platforms.MAIR]: {
        [GoogleBasemapNames.Satellite]: [
            {
                minExclusive: 5,
                maxInclusive: 9,
                opacity: MAX_COG_OPACITY - 0.5
            },
            {
                minExclusive: 9,
                maxInclusive: 19,
                opacity: MAX_COG_OPACITY - 0.6
            }
        ],
        [GoogleBasemapNames.Roadmap]: [
            {
                minExclusive: 5,
                maxInclusive: 10,
                opacity: MAX_COG_OPACITY - 0.6
            },
            {
                minExclusive: 10,
                maxInclusive: 11,
                opacity: MAX_COG_OPACITY - 0.7
            },
            {
                minExclusive: 11,
                maxInclusive: 19,
                opacity: MAX_COG_OPACITY - 0.75
            }
        ]
    }
};
